import React from 'react';

import { theme } from 'antd';

const { useToken } = theme;

const AirTemperatureIcon = ({ fillColor, innerColor }: { fillColor?: string; innerColor?: string }) => {
  const { token } = useToken();
  const currentFillColor = fillColor ?? token.colorBgContainer;
  const currentInnerColor = innerColor ?? token.colorPrimary;

  return (
    <>
      <circle cx="23" cy="20" r="12" fill={currentInnerColor} />
      <path
        d="M25 21.13V14.5C25 13.9696 24.7893 13.4609 24.4142 13.0858C24.0391 12.7107 23.5304 12.5 23 12.5C22.4696 12.5 21.9609 12.7107 21.5858 13.0858C21.2107 13.4609 21 13.9696 21 14.5V21.13C20.3885 21.5558 19.9289 22.1656 19.688 22.8707C19.4471 23.5758 19.4375 24.3394 19.6606 25.0504C19.8837 25.7613 20.328 26.3825 20.9286 26.8235C21.5292 27.2645 22.2549 27.5023 23 27.5023C23.7451 27.5023 24.4708 27.2645 25.0714 26.8235C25.672 26.3825 26.1163 25.7613 26.3394 25.0504C26.5625 24.3394 26.5529 23.5758 26.312 22.8707C26.0711 22.1656 25.6115 21.5558 25 21.13ZM23 13.5C23.2652 13.5 23.5196 13.6054 23.7071 13.7929C23.8946 13.9804 24 14.2348 24 14.5V18.5H22V14.5C22 14.2348 22.1054 13.9804 22.2929 13.7929C22.4804 13.6054 22.7348 13.5 23 13.5Z"
        fill={currentFillColor}
      />
    </>
  );
};

export default AirTemperatureIcon;
